import { EdgePlatform } from 'types'

const getPlatformLabel = (platform: EdgePlatform) => {
	switch (platform) {
		case 'DASH_CX':
			return 'DashCX'
		case 'EDGE_CX':
			return 'EdgeCX'
		case 'TURBO_CX':
			return 'TurboCX'
		default:
			return 'WhatCX'
	}
}

export default getPlatformLabel
